import React from 'react';

const Gym = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      {...props}
    >
      <path
        d="M10.375 6.5625H7.5625C7.04473 6.5625 6.625 6.98223 6.625 7.5V22.5C6.625 23.0178 7.04473 23.4375 7.5625 23.4375H10.375C10.8928 23.4375 11.3125 23.0178 11.3125 22.5V7.5C11.3125 6.98223 10.8928 6.5625 10.375 6.5625Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5625 6.5625H19.75C19.2322 6.5625 18.8125 6.98223 18.8125 7.5V22.5C18.8125 23.0178 19.2322 23.4375 19.75 23.4375H22.5625C23.0803 23.4375 23.5 23.0178 23.5 22.5V7.5C23.5 6.98223 23.0803 6.5625 22.5625 6.5625Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 9.375H26.3125C26.5611 9.375 26.7996 9.47377 26.9754 9.64959C27.1512 9.8254 27.25 10.0639 27.25 10.3125V19.6875C27.25 19.9361 27.1512 20.1746 26.9754 20.3504C26.7996 20.5262 26.5611 20.625 26.3125 20.625H23.5"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.625 20.625H3.8125C3.56386 20.625 3.3254 20.5262 3.14959 20.3504C2.97377 20.1746 2.875 19.9361 2.875 19.6875V10.3125C2.875 10.0639 2.97377 9.8254 3.14959 9.64959C3.3254 9.47377 3.56386 9.375 3.8125 9.375H6.625"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3125 15H18.8125"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.25 15H29.125"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15H2.875"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Gym;
